import { COMMON_COUNTRY_CODES } from '../../../../base/components/PopoverMonto/phoneCountries.ts'
import { normalizePhoneValue, phoneDigits } from '../../../../base/components/PopoverMonto/phoneValue.ts'

/** Código de país por defecto (Bolivia) */
export const WAAPI_CODIGO_PAIS_DEFAULT = '591'

/** Prefijos ofrecidos en el formulario, ej. { code: '591', label: 'Bolivia (+591)' } */
export const WAAPI_CODIGOS_PAIS = COMMON_COUNTRY_CODES.map((c) => ({
  code: phoneDigits(c.code),
  label: c.label,
}))

export interface WaapiTelefono {
  /** Código de país sin '+', ej. "591" */
  codigoArea: string
  /** Número local sin código de país */
  telefono: string
}

const LOCAL_MIN = 6
const LOCAL_MAX = 15

/**
 * Separa código de país y número local. Acepta "70123456", "+591 70123456", "59170123456" o
 * "+56 912345678"; con `codigoPais` el número sin '+' se toma como local.
 * @returns null si no hay un número válido (vacío, solo el código, muy corto o muy largo)
 */
export const parseTelefonoWaapi = (
  telefono?: string | null,
  codigoPais?: string | null,
): WaapiTelefono | null => {
  const valor = (telefono ?? '').trim()
  if (!phoneDigits(valor)) return null
  const codigo = phoneDigits(codigoPais ?? '') || undefined
  const r = normalizePhoneValue(
    valor,
    codigo,
    COMMON_COUNTRY_CODES.map((c) => c.code),
  )
  // Prefijo internacional desconocido y sin espacio ("+447..."): no se puede separar el código
  if (r.code === '+') return null
  const codigoArea = phoneDigits(r.code) || codigo || WAAPI_CODIGO_PAIS_DEFAULT
  const local = r.phoneNumber
  if (local.length < LOCAL_MIN || local.length > LOCAL_MAX) return null
  return { codigoArea, telefono: local }
}

/** "+591 70123456" para mostrar */
export const formatearTelefonoWaapi = (t: WaapiTelefono) => `+${t.codigoArea} ${t.telefono}`
